import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import {
  IPrivsTreeAction,
  TPaneSign,
  TTreeId,
} from '../../../models/role-privs/RolePrivsData';
import { AppState } from '../../../store/reducers/root';
import {
  getPrivsTreeActions,
  getPrivsTreeActionsDisabled,
} from '../../../store/selectors/rolePrivs';
import rolePrivs from '../../../store/slices/rolePrivs';

import PrivsActionsList from './PrivsActionsList';

interface IActionsCheckboxGroupOwnProps {
  className?: string;
  treeId: TTreeId;
  pane: TPaneSign;
  isCategoryTree?: boolean;
}

const mapStateToProps = (
  state: AppState,
  { className, treeId, pane, isCategoryTree }: IActionsCheckboxGroupOwnProps
) => ({
  options: getPrivsTreeActions(state, treeId),
  className,
  disabled:
    pane === 'all' ? false : getPrivsTreeActionsDisabled(state, treeId, pane),
  isCategoryTree,
  pane,
});

const mapDispatchToProps = {
  setCategoryPrivs: rolePrivs.setCategoryPrivs,
  setPrivs: rolePrivs.setPrivs,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  { setCategoryPrivs, setPrivs }: typeof mapDispatchToProps,
  { treeId, isCategoryTree, ...oP }: IActionsCheckboxGroupOwnProps
) => ({
  ...sP,
  ...oP,
  onChange: (action: IPrivsTreeAction) =>
    isCategoryTree
      ? setCategoryPrivs({ treeId, action })
      : setPrivs({ treeId, action }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type TPrivsActionsConnectorProps = ConnectedProps<typeof connector>;

export default connector(PrivsActionsList);
